export const deleteLocalStorageAuth = () => {
  localStorage.removeItem('amplifyRegion');
  localStorage.removeItem('amplifyUserPoolId');
  localStorage.removeItem('amplifyClientId');
  localStorage.removeItem('amplifyCognitoHostedDomain');
};
